import LocalizedStrings from "react-localization";

const MaintenanceDashboard = () => {
    return (
      <div>
          <span><h1>{strings.title}</h1></span>
          <span><h3>Modulo no disponible</h3></span>
      </div>
    )
}

const strings = new LocalizedStrings({
    es:{
        title: "Tableros de Mantenimiento"
    },
});

export default MaintenanceDashboard;